import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeGasLine } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeGasLine} />; }
